exports = module.exports = require("../../../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, ".thumbnails[data-v-35470045]{margin:auto;width:500px}.thumbnails .vueperslide[data-v-35470045]{box-sizing:border-box;border:1px solid #fff;transition:.3s ease-in-out;opacity:.7;cursor:pointer}.thumbnails .vueperslide--active[data-v-35470045]{box-shadow:0 0 6px rgba(0,0,0,.3);opacity:1}.vueperslide.vueperslide--active.vueperslide--visible[data-v-35470045]{background-size:contain;background-repeat:no-repeat}", ""]);

// exports
